export const SECTORS = [
  'B2B SaaS',
  'D2C / Consumer',
  'Fintech',
  'Health Tech',
  'EdTech',
  'Deep Tech / AI',
  'Logistics',
  'PropTech',
  'CleanTech / Climate',
  'Agri Tech',
  'Media & Entertainment',
  'Gaming',
  'Cyber Security',
  'HR Tech',
  'Legal Tech',
  'InsurTech',
  'Travel & Hospitality',
  'Food & Beverage',
  'Marketplace',
  'Developer Tools',
];